// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminPageStyles_container__2kM9Z","admin-title":"AdminPageStyles_admin-title__PKzvC","grouped-link":"AdminPageStyles_grouped-link__19jVS"};